import { IS_MAINNET, IS_TESTNET } from '@shared/utils/constant'
import { Modal, DefaultMarket } from '@/types/enums'
import { MainPage, TradeSubPage } from '@/types/page'

const BLOCKED_ROUTE_PREFIXES: string[] = [
  MainPage.Points,
  MainPage.Markets,
  MainPage.Portfolio
]

export default defineNuxtRouteMiddleware(async (to) => {
  const $pinia = usePinia()
  const sharedWalletStore = useSharedWalletStore($pinia)

  if (!sharedWalletStore.isUserConnected) {
    return
  }

  const routeName = String(to.name || '')
  const isBlocked = BLOCKED_ROUTE_PREFIXES.some(
    (prefix) => routeName === prefix || routeName.startsWith(`${prefix}-`)
  )

  if (!isBlocked) {
    return
  }

  const accessStore = useAccessStore($pinia)

  await accessStore.fetchAccessStatus()

  if (accessStore.userHasAccess) {
    return
  }

  const modalStore = useSharedModalStore($pinia)

  const defaultMarket = IS_MAINNET
    ? DefaultMarket.Perpetual
    : IS_TESTNET
      ? DefaultMarket.PerpetualTestnet
      : DefaultMarket.PerpetualDevnet

  modalStore.openModal(Modal.EstablishConnection)

  return navigateTo({
    name: TradeSubPage.Trade,
    params: { slug: defaultMarket }
  })
})
